import { createSlice } from '@reduxjs/toolkit'

const STORAGE_KEY = "leftSidebarCollapsed"

// The sidebar never leaves the layout, it only narrows to a rail of icons. Remembering
// that choice means a user who works narrow does not have to collapse it again on every
// page load.
const readStoredState = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) === "true"
    } catch {
        return false
    }
}

const writeStoredState = (isCollapsed) => {
    try {
        localStorage.setItem(STORAGE_KEY, isCollapsed ? "true" : "false")
    } catch {
        // A blocked localStorage only costs the user the remembered width, so carry on.
    }
}

export const leftSidebarSlice = createSlice({
    name: 'leftSidebar',
    initialState: {
        isCollapsed : readStoredState(),   // narrow icon rail instead of the full menu
    },
    reducers: {

        toggleLeftSidebar: (state) => {
            state.isCollapsed = !state.isCollapsed
            writeStoredState(state.isCollapsed)
        },

        setLeftSidebarCollapsed: (state, action) => {
            state.isCollapsed = action.payload
            writeStoredState(state.isCollapsed)
        },

    }
})

export const { toggleLeftSidebar, setLeftSidebarCollapsed } = leftSidebarSlice.actions

export default leftSidebarSlice.reducer
